export const localStorageHelper = {
  set: (name, value) => {
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      if (e.code === 22) {
        return false;
      }
    }
  },
  get: (name) => {
    try {
      let value = localStorage.getItem(name);

      switch (value) {
        case undefined:
          value = null;
          break;
        case null:
          value = null;
          break;
        default:
          return value;
      }
      return value;
    } catch (error) {
      return false;
    }
  },
  removeItem: (name) => {
    try {
      localStorage.removeItem(name);
    } catch (error) {
      return false;
    }
  },
  clear: () => {
    localStorage.clear();
  },
};

export const directLoginStorage = {
  set: (name, value) => {
    let directLogin = sessionStorage.getItem("directLogin") ? JSON.parse(sessionStorage.getItem("directLogin")) : {};
    try {
      directLogin[name] = value;
      sessionStorage.setItem("directLogin", JSON.stringify(directLogin));
    } catch (e) {
      if (e.code === 22) {
        return false;
      }
    }
  },
  get: (name) => {
    try {
      let directLogin = JSON.parse(sessionStorage.getItem("directLogin"));
      if (name === "directLogin") {
        return directLogin;
      }
      switch (directLogin[name]) {
        case undefined:
        case null:
          return null;
        default:
          return directLogin[name];
      }
    } catch (error) {
      return false;
    }
  },
  removeItem: (name) => {
    let directLogin = JSON.parse(sessionStorage.getItem("directLogin"));
    delete directLogin[name];

    try {
      sessionStorage.setItem("directLogin", JSON.stringify(directLogin));
    } catch (error) {
      return false;
    }
  },
  clear: () => {
    sessionStorage.removeItem("directLogin");
  },
};
